import axios from 'axios';

// Prefer explicit env override, otherwise use local API during local web dev.
// (CRA env vars must be prefixed with REACT_APP_)
// When running locally with HTTPS, the proxy in package.json handles routing to the API
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== 'undefined' && window.location?.hostname === 'localhost'
    ? '' // Use empty string for local dev - proxy will handle routing to localhost:3001
    : 'https://baptistmenapi.onrender.com');

export default axios.create({
    baseURL:BASE_URL
})

export const axiosPrivate = axios.create({
    baseURL:BASE_URL,
    headers: {
        'Content-Type':'application/json',
    },
    withCredentials:false
})
